import React, { SetStateAction } from 'react'
import {
    Editor as KendoEditor,
    EditorTools,
} from '@progress/kendo-react-editor'

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    InsertImage,
    ViewHtml,
    InsertTable,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell,
} = EditorTools

export interface IEditor {
    introMessage: string
    setIntroMessage: React.Dispatch<SetStateAction<string>>
    setIsDirty: React.Dispatch<SetStateAction<boolean>>
}
const Editor: React.FC<IEditor> = ({
    setIntroMessage,
    setIsDirty,
    introMessage,
}) => {
    return (
        <KendoEditor
            tools={[
                [Bold, Italic, Underline, Strikethrough],
                [Subscript, Superscript],
                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                [Indent, Outdent],
                [OrderedList, UnorderedList],
                FontSize,
                FontName,
                FormatBlock,
                [Undo, Redo],
                [Link, Unlink, InsertImage, ViewHtml],
                [InsertTable],
                [
                    AddRowBefore,
                    AddRowAfter,
                    AddColumnBefore,
                    AddColumnAfter,
                ],
                [DeleteRow, DeleteColumn, DeleteTable],
                [MergeCells, SplitCell],
            ]}
            contentStyle={{
                height: 250,
            }}
            className="w-full border-gray-200 border-2 rounded-md"
            defaultContent={introMessage}
            onChange={(e) => {
                setIntroMessage(e.html)
                setIsDirty(true)
            }}
        />
    )
}

export default Editor
